// Phase C — Carrier bidder hooks
import axios from "axios";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export const useCarrierLinks = (logistics_request_id, enabled = true) =>
  useQuery({
    queryKey: ["carrier-links", logistics_request_id],
    queryFn: () =>
      axios
        .get(`${API}/carrier-links`, { params: { logistics_request_id } })
        .then((r) => r.data),
    enabled: enabled && !!logistics_request_id,
  });

export const useCreateCarrierLink = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (body) => axios.post(`${API}/carrier-links`, body).then((r) => r.data),
    onSuccess: (data) => {
      qc.invalidateQueries({ queryKey: ["carrier-links", data?.link?.logistics_request_id] });
    },
  });
};

export const useRevokeCarrierLink = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (linkId) => axios.delete(`${API}/carrier-links/${linkId}`),
    onSuccess: () => qc.invalidateQueries({ queryKey: ["carrier-links"] }),
  });
};

export const useCarrierBids = (logistics_request_id, enabled = true) =>
  useQuery({
    queryKey: ["carrier-bids", logistics_request_id],
    queryFn: () =>
      axios
        .get(`${API}/carrier-links/bids`, { params: { logistics_request_id } })
        .then((r) => r.data),
    enabled: enabled && !!logistics_request_id,
  });

// Public — no auth header (axios global interceptor still attaches credentials,
// but the backend route ignores them).
export const usePublicCarrierLink = (token) =>
  useQuery({
    queryKey: ["public-carrier-link", token],
    queryFn: () => axios.get(`${API}/carrier-links/public/${token}`).then((r) => r.data),
    enabled: !!token,
    retry: false,
  });

export const usePublicSubmitBid = (token) =>
  useMutation({
    mutationFn: (body) =>
      axios.post(`${API}/carrier-links/public/${token}/submit`, body).then((r) => r.data),
  });
